import { TextField } from '@mui/material';

type StreetInputProps = {
  value: string;
  onChange: (value: string) => void;
  required: boolean;
};

export function StreetNumberInput({
  value,
  onChange,
  required,
}: StreetInputProps) {
  return (
    <TextField
      type='text'
      label='Hausnummer'
      id='street-number'
      size='small'
      value={value}
      onChange={event => onChange(event.target.value)}
      fullWidth
      required={required}
    />
  );
}
